module.exports = __webpack_public_path__ + "static/Oswald-Bold-6196564d01323973c770fe32a9dfab7c.woff2";